module.exports = __webpack_public_path__ + "static/main-sand-bkg-972d104f8a9bb46c6c82dcc92178bb6c.png";